import type { ReactNode, SyntheticEvent } from "react";

export type NotificationOptions = {
    key?: string;
    content?: (key: string, message: string) => ReactNode;
    variant?: "success" | "error" | "warning" | "info";
    action?: (key: string) => ReactNode;
    onClose?: (event: SyntheticEvent<any, Event>, reason: string, key: string) => void;
    persist?: boolean;
    preventDuplicates?: boolean;
};

export type Notification = {
    key: string;
    message: string;
    details?: string;
    options?: NotificationOptions,
    dismissed?: boolean;
};

export type NotificationsState = {
    notifications: Notification[];
    outstandingRequestCount: number;
};

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const INCREMENT_OUTSTANDING_REQUEST_COUNT = "INCREMENT_OUTSTANDING_REQUEST_COUNT";
export const DECREMENT_OUTSTANDING_REQUEST_COUNT = "DECREMENT_OUTSTANDING_REQUEST_COUNT";

type EnqueueSnackbarAction = {
    type: typeof ENQUEUE_SNACKBAR,
    notification: Notification
};

type CloseSnackbarAction = {
    type: typeof CLOSE_SNACKBAR,
    dismissAll: boolean,
    key: string
};

type RemoveSnackbarAction = {
    type: typeof REMOVE_SNACKBAR,
    key: string
};

type IncrementOutstandingRequestCountAction = {
    type: typeof INCREMENT_OUTSTANDING_REQUEST_COUNT
};

type DecrementOutstandingRequestCountAction = {
    type: typeof DECREMENT_OUTSTANDING_REQUEST_COUNT
};

export type NotificationActionTypes = EnqueueSnackbarAction | CloseSnackbarAction | RemoveSnackbarAction | IncrementOutstandingRequestCountAction | DecrementOutstandingRequestCountAction;

export type DispatchNotificationAction = (action: NotificationActionTypes) => void;